import React from 'react';
import { CardTW } from 'tailwindComponents/CardTW/CardTW';
import { IPotentialMatch } from './IPotentialMatch';
import { ISearchOrderResultData } from 'ui-toolkit/orders/searchOrder/types/ISearchOrdersResult';
import { ExpectedOrderDisplay } from './ExpectedOrderDisplay';

export interface IExpectedOrderTableDisplayProps {
  data: ISearchOrderResultData;
  setPotentialMatch: (x: IPotentialMatch) => void;
}

export const ExpectedOrderTableDisplay: React.FC<IExpectedOrderTableDisplayProps> = ({ data, setPotentialMatch }) => {
  return (
    <CardTW
      title={
        <>
          Orders by File Number
          {data && (
            <span className="rounded-full font-medium text-xs px-2 py-1 bg-green-100 text-green-700 ml-8 align-middle">
              {data.content.length} Item{data.content.length === 1 ? '' : 's'}
            </span>
          )}
        </>
      }
      isCollapsible
      isCollapsed
      contentClassName={'px-0'}
    >
      <div>
        {data.content.map((expectedOrder) => (
          <ExpectedOrderDisplay
            key={expectedOrder.id}
            expectedOrder={expectedOrder}
            actionLabel={'Match'}
            onAction={() => setPotentialMatch({ expectedOrder })}
          />
        ))}
      </div>
    </CardTW>
  );
};
